
<template>
    <div class="error-box" >
        <div class="error-flex">
            <img class="error-img" src="@/assets/images/404.png" background-size="cover" />
            <p>{{markedWords}}</p>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            markedWords:'亲爱的家长用户，很抱歉，您当前访问的页面出现了错误，请退出重新尝试；',//提示语
        };
    },
    created() {
    },
    methods: {
        /**
         * 拨打电话
         */
        callThisnum(val){
            window.location.href = "tel:"+val;
        },
        /**
         * 返回上一级
         */
        backPage() {
            this.$router.back(-1);
        },
    }
};
</script>

<style lang="scss" scoped>
.error-box{
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 280px 80px 0;
}
.error-flex{
  display: flex;
  flex-direction: column;
  align-items: center;
}
.error-img{
  width: 168px;
  height: 168px;
  margin-bottom: 50px;
}
.error-flex>p{
  font-size: 26px;
  color: #999999;
}

</style>
<style lang="scss">
</style>